<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12">
        <v-toolbar dense flat color="secondary" dark>
          <v-toolbar-title class="title text-center text-md-left">
            Other items
          </v-toolbar-title>
        </v-toolbar>
      </v-col>
      <v-col cols="12" md="6">
        <div>
          Will You Charge a Fee to Event Participants?
        </div>
        <v-radio-group row v-model="event.charge">
          <v-radio value="yes" label="Yes" color="accent"></v-radio>
          <v-radio value="no" label="No" color="accent"></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="12" md="6" v-if="event.charge == 'yes'">
        <div>
          What will this fee cover? What other fees may be involved?
        </div>
        <v-textarea 
          v-model="event.costInfo" 
          color="secondary" 
          outlined
        >
        </v-textarea>
      </v-col>
      <v-col cols="12" md="6">
        <div>
          Will Food or Drink (Non-Alcoholic Only) be Served?
        </div>
        <v-radio-group row v-model="event.food">
          <v-radio value="yes" label="Yes" color="accent"></v-radio>
          <v-radio value="no" label="No" color="accent"></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field outlined color="secondary" label="How Many Participants Do You Anticpate Attending?" v-model="event.expectedNum"></v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    eventInfo : Object
  },
  data(){
    return {
      event : this.eventInfo,
    }
  }
}
</script>
